import { useEffect } from 'react';
import * as turf from '@turf/turf';

export default function useFeatureMarkers({
    mapRef,
    longstandingGeoJSONRef,
    multuGroupSelectedArray = []
}) {

    useEffect(() => {

        if (!mapRef.current) return;

        const features = longstandingGeoJSONRef.current?.features;

        if (!features?.length) return;

        const selectedFeatures = features.filter(feature =>
            multuGroupSelectedArray.includes(feature.skylark_id)
        );

        const markerFeatures = selectedFeatures
            .map(feature => {

                // POINT
                if (feature.geometry?.type === 'Point') {
                    return {
                        type: 'Feature',
                        geometry: feature.geometry,
                        properties: {
                            skylark_id: feature.skylark_id,
                        },
                    };
                }

                // POLYGON / MULTIPOLYGON
                if (
                    feature.geometry?.type === 'Polygon' ||
                    feature.geometry?.type === 'MultiPolygon'
                ) {
                    return turf.pointOnFeature({
                        type: 'Feature',
                        geometry: feature.geometry,
                        properties: {
                            skylark_id: feature.skylark_id,
                        },
                    });
                }

                return null;

            })
            .filter(Boolean);

        const markerGeoJSON = {
            type: 'FeatureCollection',
            features: markerFeatures,
        };

        const map = mapRef.current;

        if (map.getSource('clicked-feature-source')) {

            map
                .getSource('clicked-feature-source')
                .setData(markerGeoJSON);

        } else {

            map.addSource('clicked-feature-source', {
                type: 'geojson',
                data: markerGeoJSON,
            });

            map.addLayer({
                id: 'clicked-feature-marker',
                type: 'circle',
                source: 'clicked-feature-source',
                paint: {
                    'circle-radius': 4,
                    'circle-color': 'transparent',
                    'circle-stroke-color': '#ffffff',
                    'circle-stroke-width': 1,
                },
            });
        }

        return () => {

            if (!mapRef.current) return;

            if (mapRef.current.getLayer('clicked-feature-marker')) {
                mapRef.current.removeLayer('clicked-feature-marker');
            }

            if (mapRef.current.getSource('clicked-feature-source')) {
                mapRef.current.removeSource('clicked-feature-source');
            }
        };

    }, [
        multuGroupSelectedArray
    ]);
}
